<template>
  <div class="e-empty" :class="{ 'e-empty__border': withBorder }">
    <div class="e-empty__content">
      <div v-if="icon" class="e-empty__icon my-1">
        <e-icon color="dark" :icon="icon" />
      </div>
      <div v-if="title" class="e-empty__title my-1">
        {{ title }}
      </div>
      <div v-if="description" class="e-empty__description my-1">
        {{ description }}
      </div>
    </div>
  </div>
</template>

<script>
import { EIcon } from '../vuetify'

export default {
  name: 'EEmpty',

  components: {
    EIcon,
  },

  props: {
    icon: {
      type: String,
      default: 'icon-info',
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    withBorder: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
